import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { STORE_SERVICES_CLASSES } from "./constants";

export const StoreServicesContainer = styled(Container)(({ theme }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(3),

    [BREAKPOINT_DESKTOP]: {
      marginBottom: theme.spacing(6),
    },

    [`& .${STORE_SERVICES_CLASSES.title}`]: {
      ...theme.typography.h5,
      [BREAKPOINT_TABLET]: {
        ...theme.typography.h4,
      },
      [BREAKPOINT_DESKTOP]: {
        ...theme.typography.h3,
      },
    },
  };
});
